/** Copy for the workshop board, job list and job workspace. */

export const workshopEn = {
  'walkin.button': 'New walk-in',
  'walkin.title': 'New walk-in',
  'walkin.subtitle': 'A car that arrived without a booking',
  'walkin.customer': 'Customer',
  'walkin.find': 'Find an existing customer',
  'walkin.findHint': 'Name or phone (3+ characters)',
  'walkin.orNew': 'Or add a new customer:',
  'walkin.change': 'Change',
  'walkin.firstName': 'First name',
  'walkin.lastName': 'Last name',
  'walkin.phone': 'Phone',
  'walkin.email': 'Email (optional)',
  'walkin.car': 'Car',
  'walkin.whichCar': 'Which car',
  'walkin.newCar': 'Another car…',
  'walkin.brand': 'Make',
  'walkin.model': 'Model',
  'walkin.year': 'Year',
  'walkin.plate': 'Plate',
  'walkin.job': 'Job',
  'walkin.service': 'Service',
  'walkin.problem': 'What the customer says',
  'walkin.branch': 'Branch',
  'walkin.open': 'Open job',
  'walkin.needService': 'Add the service.',
  'walkin.needCustomer': 'Pick a customer, or add a first name and phone.',
  'walkin.needCar': 'Add the car make.',
  'navgroup.workshop': 'Workshop',
  'navgroup.office': 'Office',
  'nav.menu': 'Menu',

  'stage.booked': 'Booked',
  'stage.checked_in': 'Checked in',
  'stage.inspection': 'Inspection',
  'stage.in_progress': 'In progress',
  'stage.ready': 'Ready for pickup',
  'stage.completed': 'Completed',
  'stage.cancelled': 'Cancelled',
  'stageHint.booked': 'Appointment made',
  'stageHint.checked_in': 'Car received',
  'stageHint.inspection': 'Inspect, diagnose, quote',
  'stageHint.in_progress': 'Parts and repair',
  'stageHint.ready': 'Waiting for the customer',
  'stageHint.completed': 'Handed back',

  'next.confirm': 'Confirm booking',
  'next.confirm.hint': 'The customer is told their slot is confirmed.',
  'next.checkin': 'Check in car',
  'next.checkin.hint': 'Record mileage, fuel, photos and the customer’s signature when the car arrives.',
  'next.await_checkin': 'Waiting for check-in',
  'next.await_checkin.hint': 'A service advisor checks the car in when it arrives.',
  'next.assign': 'Assign a mechanic',
  'next.assign.hint': 'Choose who will work on this car.',
  'next.inspect': 'Start inspection',
  'next.inspect.hint': 'Fill in the health report: mileage, photos, findings and scores.',
  'next.finish_inspection': 'Finish inspection',
  'next.finish_inspection.hint': 'Finalize the health report before quoting or starting work.',
  'next.prepare_quote': 'Prepare quote',
  'next.prepare_quote.hint': 'Log parts and labour, then send the quote to the customer.',
  'next.await_approval': 'Waiting for customer approval',
  'next.await_approval.hint': 'The quote has been sent. Start work once the customer approves.',
  'next.review_quote': 'Review declined quote',
  'next.review_quote.hint': 'The customer declined the quote. Call them or revise it.',
  'next.start_work': 'Start work',
  'next.start_work.hint': 'Move the car into repair.',
  'next.parts_ordered': 'Waiting on parts',
  'next.parts_ordered.hint': 'Pause the job until parts arrive.',
  'next.parts_arrived': 'Parts arrived — continue work',
  'next.parts_arrived.hint': 'This job is paused waiting for parts.',
  'next.quality_check': 'Work done — quality check',
  'next.quality_check.hint': 'Road-test and check the work before handing back.',
  'next.car_wash': 'Send to car wash',
  'next.car_wash.hint': 'Optional wash before pickup.',
  'next.mark_ready': 'Mark ready for pickup',
  'next.mark_ready.hint': 'The customer gets a message that the car is ready.',
  'next.skip_checkin': 'Skip check-in — car has arrived',
  'next.skip_checkin.hint': 'Mark the car as received without mileage, photos or signature.',
  'job.skipTitle': 'Skip check-in?',
  'job.skipConfirm': 'The car is marked as received without mileage, fuel, photos or the customer’s signature. This can’t be undone.',
  'job.skipReason': 'Reason (optional)',
  'job.skipDo': 'Skip check-in',
  'job.skipped': 'Check-in was skipped ({when}).',
  'job.skippedReason': 'Reason: {reason}',
  'job.handoverTitle': 'Hand the car back',
  'job.handoverHint': 'An invoice is issued from the approved quote, and the customer is thanked in the app.',
  'job.handoverPaid': 'Paid — hand over',
  'job.handoverUnpaid': 'Hand over, not paid yet',
  'job.invoiceIssued': 'Invoice {status}: {amount}',
  'job.invoicePaid': 'paid',
  'job.invoiceUnpaid': 'issued, not paid',
  'job.noInvoice': 'Handed over. No approved quote, so no invoice was issued.',
  'next.handover': 'Hand over to customer',
  'next.handover.hint': 'Confirm the customer has collected the car.',

  'wait.customer': 'Waiting on customer',
  'wait.parts': 'Waiting on parts',
  'attn.confirm': 'Needs confirming',
  'attn.late': 'Late — not arrived',
  'attn.unassigned': 'No mechanic',
  'attn.declined': 'Quote declined',

  'today.title': 'Today',
  'today.lede': 'What’s in the workshop, and what needs doing next.',
  'today.mine': 'My jobs only',
  'today.allJobs': 'All jobs',
  'today.count.attention': 'Need attention',
  'today.count.workshop': 'In the workshop',
  'today.count.waiting': 'Waiting',
  'today.count.arriving': 'Arriving today',
  'today.count.ready': 'Ready for pickup',
  'today.sec.attention': 'Needs attention',
  'today.sec.attention.hint': 'Sort these out first.',
  'today.sec.workshop': 'In the workshop',
  'today.sec.workshop.hint': 'Cars being worked on right now.',
  'today.sec.waiting': 'Waiting on something',
  'today.sec.waiting.hint': 'Paused until the customer or a supplier responds.',
  'today.sec.arriving': 'Arriving today',
  'today.sec.ready': 'Ready for pickup',
  'today.sec.done': 'Completed today',
  'today.sec.upcoming': 'Coming up',
  'today.empty.attention': 'All clear — nothing needs attention.',
  'today.empty.workshop': 'No cars in the workshop right now.',
  'today.empty.lane': 'None',
  'today.empty.waiting': 'Nothing on hold.',
  'today.empty.arriving': 'No more arrivals today.',
  'today.empty.ready': 'No cars waiting for pickup.',
  'today.empty.done': 'Nothing handed over yet today.',
  'today.empty.upcoming': 'Nothing booked for the next 7 days.',
  'today.more': '+{n} more',

  'jobs.title': 'Jobs',
  'jobs.lede': 'Every car, where it is, and what happens next.',
  'jobs.f.today': 'Today',
  'jobs.f.active': 'In the workshop',
  'jobs.f.upcoming': 'Upcoming',
  'jobs.f.waiting': 'Waiting',
  'jobs.f.attention': 'Needs attention',
  'jobs.f.ready': 'Ready for pickup',
  'jobs.f.completed': 'Completed',
  'jobs.f.cancelled': 'Cancelled',
  'jobs.f.all': 'All',
  'jobs.search': 'Search customer, phone, car, plate or service',
  'jobs.dates': 'Dates',
  'jobs.clearDates': 'Clear dates',
  'jobs.view.list': 'List',
  'jobs.view.board': 'Board',
  'jobs.col.time': 'Time',
  'jobs.col.vehicle': 'Vehicle',
  'jobs.col.customer': 'Customer',
  'jobs.col.service': 'Service',
  'jobs.col.mechanic': 'Mechanic',
  'jobs.col.stage': 'Stage',
  'jobs.col.next': 'Next step',
  'jobs.empty': 'No jobs in this view.',
  'jobs.loading': 'Loading jobs…',
  'jobs.count': '{n} jobs',
  'jobs.count1': '1 job',
  'jobs.done': 'Nothing to do',

  'job.back': 'Jobs',
  'job.nextStep': 'Next step',
  'job.nothingNext': 'Nothing left to do on this job.',
  'job.cancelledNote': 'This job was cancelled.',
  'job.otherOptions': 'Or',
  'job.progress': 'Progress',
  'job.appointment': 'Appointment',
  'job.customer': 'Customer',
  'job.vehicle': 'Vehicle',
  'job.service': 'Requested service',
  'job.mechanic': 'Mechanic',
  'job.notes': 'Customer’s notes',
  'job.noNotes': 'No notes from the customer.',
  'job.pickupNotes': 'Pickup notes',
  'job.branch': 'Branch',
  'job.mileage': 'Mileage',
  'job.vin': 'VIN',
  'job.call': 'Call',
  'job.customerFile': 'Customer file',
  'job.customerFileOpen': 'Open customer & car history',
  'job.customerFileHint': 'Contact details, this car’s record, past visits, health reports, and passport.',
  'job.customerFileSubtitle': 'Registration, cars & visit history',
  'job.preferred': 'Customer asked for {name}',
  'job.photos': 'Customer photos',
  'job.tab.checkin': 'Check-in',
  'job.tab.inspection': 'Inspection',
  'job.tab.work': 'Parts & work',
  'job.tab.quote': 'Quote',
  'job.tabLocked': 'Available once the car is checked in.',
  'job.checkinWaiting': 'The car has not been checked in yet. A service advisor or admin can check it in here or in the Service Advisor app.',
  'job.detailed': 'Detailed steps',
  'job.detailedHint': 'The finer steps the customer sees in their app. Tap one to move the job there.',
  'job.override': 'Change status manually',
  'job.overrideHint': 'Admins only — use when a job is in the wrong state.',
  'job.cancel': 'Cancel job',
  'job.cancelConfirm': 'Cancel this job? The customer will be notified.',
  'job.keep': 'Keep job',
  'job.stepDone': 'Done',
  'job.stepNow': 'Now',
  'job.handedOver': 'Handed over to the customer.',
  'job.km': '{n} km',
  'next.review_qc': 'Review quality check',
  'next.review_qc.hint': 'The mechanic has finished and is asking for sign-off.',
  'next.review_parts': 'Review parts request',
  'next.review_parts.hint': 'The mechanic needs parts. Approve (order) them or reject the request.',
  'next.await_qc_review': 'Waiting for QC sign-off',
  'next.await_qc_review.hint': 'The service desk is reviewing your quality check.',
  'next.await_parts_review': 'Waiting for parts approval',
  'next.await_parts_review.hint': 'The service desk is reviewing your parts request.',
  'wait.approval': 'Waiting for desk',
  'attn.parts_request': 'Parts request',
  'attn.qc_request': 'QC sign-off',
  'attn.uncollected': 'Not collected',
  'attn.chase_customer': 'Chase customer',
  'attn.stuck': 'Overdue',
  'dur.min': '{n} min',
  'dur.h': '{n} h',
  'dur.d': '{n} d',
  'dur.in': '{d} here',
  'quick.again': 'Tap again to confirm',
  'quick.failed': 'Could not update: {msg}',
  'live.on': 'Live',
  'req.title': 'Requests from the mechanic',
  'req.parts': 'Parts',
  'req.qc': 'Quality check',
  'req.qty': 'Qty {n}',
  'req.urgency.low': 'Low',
  'req.urgency.normal': 'Normal',
  'req.urgency.urgent': 'Urgent',
  'req.status.pending': 'Waiting for you',
  'req.status.approved': 'Ordered',
  'req.status.fulfilled': 'Arrived',
  'req.status.rejected': 'Rejected',
  'req.approve': 'Approve & order',
  'req.reject': 'Reject',
  'req.arrived': 'Mark arrived',
  'req.qcApprove': 'Sign off',
  'req.qcReject': 'Needs more work',
  'req.qcRequested': 'Requested {when}',
  'req.none': 'No requests from the mechanic.',
  'req.qcSigned': 'Signed off',
};

export const workshopAr = {
  'walkin.button': 'عميل بدون حجز',
  'walkin.title': 'عميل بدون حجز',
  'walkin.subtitle': 'سيارة وصلت دون حجز مسبق',
  'walkin.customer': 'العميل',
  'walkin.find': 'ابحث عن عميل حالي',
  'walkin.findHint': 'الاسم أو الهاتف (3 أحرف على الأقل)',
  'walkin.orNew': 'أو أضف عميلًا جديدًا:',
  'walkin.change': 'تغيير',
  'walkin.firstName': 'الاسم الأول',
  'walkin.lastName': 'اسم العائلة',
  'walkin.phone': 'الهاتف',
  'walkin.email': 'البريد الإلكتروني (اختياري)',
  'walkin.car': 'السيارة',
  'walkin.whichCar': 'أي سيارة',
  'walkin.newCar': 'سيارة أخرى…',
  'walkin.brand': 'الماركة',
  'walkin.model': 'الموديل',
  'walkin.year': 'السنة',
  'walkin.plate': 'اللوحة',
  'walkin.job': 'العمل',
  'walkin.service': 'الخدمة',
  'walkin.problem': 'ما يقوله العميل',
  'walkin.branch': 'الفرع',
  'walkin.open': 'فتح العمل',
  'walkin.needService': 'أضف الخدمة.',
  'walkin.needCustomer': 'اختر عميلًا، أو أضف الاسم الأول والهاتف.',
  'walkin.needCar': 'أضف ماركة السيارة.',
  'navgroup.workshop': 'الورشة',
  'navgroup.office': 'المكتب',
  'nav.menu': 'القائمة',

  'stage.booked': 'محجوز',
  'stage.checked_in': 'تم الاستلام',
  'stage.inspection': 'الفحص',
  'stage.in_progress': 'قيد العمل',
  'stage.ready': 'جاهزة للاستلام',
  'stage.completed': 'مكتمل',
  'stage.cancelled': 'ملغى',
  'stageHint.booked': 'تم الحجز',
  'stageHint.checked_in': 'السيارة في الورشة',
  'stageHint.inspection': 'فحص وتشخيص وعرض سعر',
  'stageHint.in_progress': 'قطع غيار وإصلاح',
  'stageHint.ready': 'بانتظار العميل',
  'stageHint.completed': 'تم التسليم',

  'next.confirm': 'تأكيد الحجز',
  'next.confirm.hint': 'سيتم إبلاغ العميل بتأكيد موعده.',
  'next.checkin': 'استلام السيارة',
  'next.checkin.hint': 'سجّل العداد والوقود والصور وتوقيع العميل عند وصول السيارة.',
  'next.await_checkin': 'بانتظار الاستلام',
  'next.await_checkin.hint': 'يستلم مستشار الخدمة السيارة عند وصولها.',
  'next.assign': 'تعيين ميكانيكي',
  'next.assign.hint': 'اختر من سيعمل على هذه السيارة.',
  'next.inspect': 'بدء الفحص',
  'next.inspect.hint': 'املأ تقرير الحالة: العداد والصور والملاحظات والتقييمات.',
  'next.finish_inspection': 'إنهاء الفحص',
  'next.finish_inspection.hint': 'اعتمد تقرير الحالة قبل عرض السعر أو بدء العمل.',
  'next.prepare_quote': 'إعداد عرض السعر',
  'next.prepare_quote.hint': 'سجّل القطع والعمالة ثم أرسل العرض للعميل.',
  'next.await_approval': 'بانتظار موافقة العميل',
  'next.await_approval.hint': 'تم إرسال العرض. ابدأ العمل بعد موافقة العميل.',
  'next.review_quote': 'مراجعة العرض المرفوض',
  'next.review_quote.hint': 'رفض العميل العرض. اتصل به أو عدّل العرض.',
  'next.start_work': 'بدء العمل',
  'next.start_work.hint': 'انقل السيارة إلى الإصلاح.',
  'next.parts_ordered': 'بانتظار قطع الغيار',
  'next.parts_ordered.hint': 'أوقف العمل مؤقتًا حتى وصول القطع.',
  'next.parts_arrived': 'وصلت القطع — متابعة العمل',
  'next.parts_arrived.hint': 'العمل متوقف بانتظار قطع الغيار.',
  'next.quality_check': 'انتهى العمل — فحص الجودة',
  'next.quality_check.hint': 'جرّب السيارة وافحص العمل قبل التسليم.',
  'next.car_wash': 'إرسال للغسيل',
  'next.car_wash.hint': 'غسيل اختياري قبل الاستلام.',
  'next.mark_ready': 'جاهزة للاستلام',
  'next.mark_ready.hint': 'سيصل للعميل إشعار بأن السيارة جاهزة.',
  'next.skip_checkin': 'تخطي الاستلام — وصلت السيارة',
  'next.skip_checkin.hint': 'سجّل استلام السيارة دون العداد أو الصور أو التوقيع.',
  'job.skipTitle': 'تخطي الاستلام؟',
  'job.skipConfirm': 'سيتم تسجيل استلام السيارة دون العداد أو الوقود أو الصور أو توقيع العميل. لا يمكن التراجع عن ذلك.',
  'job.skipReason': 'السبب (اختياري)',
  'job.skipDo': 'تخطي الاستلام',
  'job.skipped': 'تم تخطي الاستلام ({when}).',
  'job.skippedReason': 'السبب: {reason}',
  'job.handoverTitle': 'تسليم السيارة',
  'job.handoverHint': 'تصدر فاتورة من عرض السعر المعتمد، ويصل للعميل شكر في التطبيق.',
  'job.handoverPaid': 'تم الدفع — تسليم',
  'job.handoverUnpaid': 'تسليم دون دفع حاليًا',
  'job.invoiceIssued': 'الفاتورة {status}: {amount}',
  'job.invoicePaid': 'مدفوعة',
  'job.invoiceUnpaid': 'صادرة وغير مدفوعة',
  'job.noInvoice': 'تم التسليم. لا يوجد عرض سعر معتمد، لذا لم تصدر فاتورة.',
  'next.handover': 'تسليم السيارة للعميل',
  'next.handover.hint': 'أكّد أن العميل استلم السيارة.',

  'wait.customer': 'بانتظار العميل',
  'wait.parts': 'بانتظار القطع',
  'attn.confirm': 'يحتاج تأكيد',
  'attn.late': 'متأخر — لم يصل',
  'attn.unassigned': 'بدون ميكانيكي',
  'attn.declined': 'العرض مرفوض',

  'today.title': 'اليوم',
  'today.lede': 'ما في الورشة الآن وما الخطوة التالية.',
  'today.mine': 'أعمالي فقط',
  'today.allJobs': 'كل الأعمال',
  'today.count.attention': 'تحتاج متابعة',
  'today.count.workshop': 'في الورشة',
  'today.count.waiting': 'بالانتظار',
  'today.count.arriving': 'تصل اليوم',
  'today.count.ready': 'جاهزة للاستلام',
  'today.sec.attention': 'تحتاج متابعة',
  'today.sec.attention.hint': 'ابدأ بهذه أولًا.',
  'today.sec.workshop': 'في الورشة',
  'today.sec.workshop.hint': 'سيارات يجري العمل عليها الآن.',
  'today.sec.waiting': 'بانتظار شيء',
  'today.sec.waiting.hint': 'متوقفة حتى يرد العميل أو المورّد.',
  'today.sec.arriving': 'تصل اليوم',
  'today.sec.ready': 'جاهزة للاستلام',
  'today.sec.done': 'اكتملت اليوم',
  'today.sec.upcoming': 'القادم',
  'today.empty.attention': 'كل شيء على ما يرام — لا شيء يحتاج متابعة.',
  'today.empty.workshop': 'لا توجد سيارات في الورشة الآن.',
  'today.empty.lane': 'لا شيء',
  'today.empty.waiting': 'لا شيء متوقف.',
  'today.empty.arriving': 'لا وصول آخر اليوم.',
  'today.empty.ready': 'لا سيارات بانتظار الاستلام.',
  'today.empty.done': 'لم يتم تسليم شيء اليوم بعد.',
  'today.empty.upcoming': 'لا حجوزات في الأيام السبعة القادمة.',
  'today.more': '+{n} أخرى',

  'jobs.title': 'أوامر العمل',
  'jobs.lede': 'كل سيارة، أين هي، وما الخطوة التالية.',
  'jobs.f.today': 'اليوم',
  'jobs.f.active': 'في الورشة',
  'jobs.f.upcoming': 'القادمة',
  'jobs.f.waiting': 'بالانتظار',
  'jobs.f.attention': 'تحتاج متابعة',
  'jobs.f.ready': 'جاهزة للاستلام',
  'jobs.f.completed': 'مكتملة',
  'jobs.f.cancelled': 'ملغاة',
  'jobs.f.all': 'الكل',
  'jobs.search': 'ابحث بالعميل أو الهاتف أو السيارة أو اللوحة أو الخدمة',
  'jobs.dates': 'التواريخ',
  'jobs.clearDates': 'مسح التواريخ',
  'jobs.view.list': 'قائمة',
  'jobs.view.board': 'لوحة',
  'jobs.col.time': 'الموعد',
  'jobs.col.vehicle': 'السيارة',
  'jobs.col.customer': 'العميل',
  'jobs.col.service': 'الخدمة',
  'jobs.col.mechanic': 'الميكانيكي',
  'jobs.col.stage': 'المرحلة',
  'jobs.col.next': 'الخطوة التالية',
  'jobs.empty': 'لا توجد أعمال في هذا العرض.',
  'jobs.loading': 'جارٍ تحميل الأعمال…',
  'jobs.count': '{n} أعمال',
  'jobs.count1': 'عمل واحد',
  'jobs.done': 'لا شيء مطلوب',

  'job.back': 'أوامر العمل',
  'job.nextStep': 'الخطوة التالية',
  'job.nothingNext': 'لا شيء متبقٍ في هذا العمل.',
  'job.cancelledNote': 'تم إلغاء هذا العمل.',
  'job.otherOptions': 'أو',
  'job.progress': 'التقدّم',
  'job.appointment': 'الموعد',
  'job.customer': 'العميل',
  'job.vehicle': 'السيارة',
  'job.service': 'الخدمة المطلوبة',
  'job.mechanic': 'الميكانيكي',
  'job.notes': 'ملاحظات العميل',
  'job.noNotes': 'لا توجد ملاحظات من العميل.',
  'job.pickupNotes': 'ملاحظات الاستلام',
  'job.branch': 'الفرع',
  'job.mileage': 'العداد',
  'job.vin': 'رقم الشاسيه',
  'job.call': 'اتصال',
  'job.customerFile': 'ملف العميل',
  'job.customerFileOpen': 'فتح سجل العميل والسيارة',
  'job.customerFileHint': 'بيانات التواصل، سجل هذه السيارة، الزيارات السابقة، تقارير الحالة، والجواز.',
  'job.customerFileSubtitle': 'التسجيل والسيارات وسجل الزيارات',
  'job.preferred': 'طلب العميل {name}',
  'job.photos': 'صور العميل',
  'job.tab.checkin': 'الاستلام',
  'job.tab.inspection': 'الفحص',
  'job.tab.work': 'القطع والعمل',
  'job.tab.quote': 'عرض السعر',
  'job.tabLocked': 'متاح بعد استلام السيارة.',
  'job.checkinWaiting': 'لم يتم استلام السيارة بعد. يمكن لمستشار الخدمة أو المدير استلامها هنا أو من تطبيق مستشار الخدمة.',
  'job.detailed': 'الخطوات التفصيلية',
  'job.detailedHint': 'الخطوات التي يراها العميل في تطبيقه. اضغط على خطوة لنقل العمل إليها.',
  'job.override': 'تغيير الحالة يدويًا',
  'job.overrideHint': 'للمديرين فقط — عند وجود العمل في حالة خاطئة.',
  'job.cancel': 'إلغاء العمل',
  'job.cancelConfirm': 'إلغاء هذا العمل؟ سيتم إبلاغ العميل.',
  'job.keep': 'الإبقاء على العمل',
  'job.stepDone': 'تم',
  'job.stepNow': 'الآن',
  'job.handedOver': 'تم تسليم السيارة للعميل.',
  'job.km': '{n} كم',

  'next.review_qc': 'مراجعة فحص الجودة',
  'next.review_qc.hint': 'أنهى الميكانيكي العمل ويطلب الاعتماد.',
  'next.review_parts': 'مراجعة طلب القطع',
  'next.review_parts.hint': 'يحتاج الميكانيكي قطع غيار. وافق (اطلبها) أو ارفض الطلب.',
  'next.await_qc_review': 'بانتظار اعتماد الجودة',
  'next.await_qc_review.hint': 'مكتب الخدمة يراجع فحص الجودة الخاص بك.',
  'next.await_parts_review': 'بانتظار الموافقة على القطع',
  'next.await_parts_review.hint': 'مكتب الخدمة يراجع طلب القطع الخاص بك.',
  'wait.approval': 'بانتظار المكتب',
  'attn.parts_request': 'طلب قطع',
  'attn.qc_request': 'اعتماد الجودة',
  'attn.uncollected': 'لم تُستلم',
  'attn.chase_customer': 'تابع العميل',
  'attn.stuck': 'متأخر',
  'dur.min': '{n} د',
  'dur.h': '{n} س',
  'dur.d': '{n} يوم',
  'dur.in': 'منذ {d}',
  'quick.again': 'اضغط مرة أخرى للتأكيد',
  'quick.failed': 'تعذّر التحديث: {msg}',
  'live.on': 'مباشر',
  'req.title': 'طلبات الميكانيكي',
  'req.parts': 'قطع غيار',
  'req.qc': 'فحص الجودة',
  'req.qty': 'الكمية {n}',
  'req.urgency.low': 'منخفض',
  'req.urgency.normal': 'عادي',
  'req.urgency.urgent': 'عاجل',
  'req.status.pending': 'بانتظارك',
  'req.status.approved': 'تم الطلب',
  'req.status.fulfilled': 'وصلت',
  'req.status.rejected': 'مرفوض',
  'req.approve': 'موافقة وطلب',
  'req.reject': 'رفض',
  'req.arrived': 'تم الوصول',
  'req.qcApprove': 'اعتماد',
  'req.qcReject': 'يحتاج عمل إضافي',
  'req.qcRequested': 'طُلب {when}',
  'req.none': 'لا توجد طلبات من الميكانيكي.',
  'req.qcSigned': 'تم الاعتماد',
};
